<template>
  <AppNavbar />
  <main class="bg-gray-50 dark:bg-gray-900 min-h-screen flex flex-col">
    <RouterView v-slot="{ Component }">
      <keep-alive :include="cachedViews">
        <component :is="Component" />
      </keep-alive>
    </RouterView>
  </main>
  <FloatingButtons :is-bottom-padded="route.name === 'job-detail'" />
  <AppToast />
</template>

<script setup>
import { onMounted } from 'vue';
import { RouterView, useRoute } from 'vue-router';
import AppNavbar from '@/components/layout/AppNavbar.vue';
import FloatingButtons from '@/components/home/FloatingButtons.vue';
import AppToast from '@/components/AppToast.vue';
import { initFlowbite } from 'flowbite';

const route = useRoute();

const cachedViews = ['HomeView'];

onMounted(() => {
  initFlowbite();
});
</script>

<style>
/* Any custom styles could go here, but with tailwind and flowbite it's often minimal */
</style>
